import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ContrattiActions";
import { Contratto } from "../generated";

class ImpiantiStore extends AbstractLookupStore<Contratto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getByImpianto, result => this.set(result.idImpianto.toString(), result.contratti))
            .onfunction(Actions.add, result => this.set(result.idImpianto.toString(), result.contratti))
            .onfunction(Actions.update, result => this.set(result.idImpianto.toString(), result.contratti))
            .onfunction(Actions.delete, result => this.set(result.idImpianto.toString(), result.contratti))
            ;
    }

    public useContratti = (idImpianto: number) => {
        return this.useStoreWithAction(
            idImpianto.toString(),
            idImpianto => Actions.getByImpianto(parseInt(idImpianto)),
            x => x.fineValidita
        );
    }
}

export default new ImpiantiStore()
